import { createAxiosInstance, createAxiosInstanceForBank } from "./axios";
import { Urls } from "./urls";

const axios = createAxiosInstance();

export const fetchOtpData = async (phoneNumber, lanId) => {
  try {
    let payload = {
      phoneNumber: phoneNumber,
      lanId: lanId,
    };
    console.log(payload, "payload");
    const response = await axios.post(Urls.sendOtp, payload);
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from send otp api--------------",
    );
    return err;
  }
};

export const fetchSoftPullOtpData = async (data) => {
  try {
    let payload = {
      data: data,
    };
    console.log(payload, "softpull otp payload");
    const response = await axios.post(Urls.sendSoftpullOtp, payload);
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from send softpull otp api--------------",
    );
    return err;
  }
};

export const fetchVerifySoftPullOtp = async (
  data,
  otp,
) => {
  try {
    let payload = {
      data: data,
      otp: otp,
    };
    const response = await axios.post(Urls.verifySoftpullOtp, payload);
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from verify softpull otp api--------------",
    );
    return err;
  }
};

export const fetchCibilReportLink = async (data, token) => {
  try {
    let payload = {
      data: data,
    };
    const response = await axios.post(Urls.generateCibilReportLink, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log(
      '------------ error while fetching data from generate cibil report link api--------------',
    );
    return err;
  }
};

export const fetchVerifyOtp = async (phoneNumber, otp, lanId) => {
  try {
    let payload = {
      phoneNumber: phoneNumber,
      otp: otp,
      lanId: lanId,
    };
    const response = await axios.post(Urls.verifyOtp, payload);
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from  verify otp api--------------",
    );
    return err;
  }
};

export const fetchUserDetails = async (lanId, token) => {
  try {
    let payload = {
      lanId: lanId ? lanId : "",
    };
    const response = await axios.post(Urls.userDetails, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log(
      err,
      "------------ error while fetching data from  verify otp api--------------",
    );
    return err;
  }
};

export const fetchMandateModes = async (token, lanId) => {
  let payload = {
    lanId: lanId ? lanId : "",
  };
  try {
    const response = await axios.post(Urls.getMandateModes, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from  get mandate modes api--------------",
    );
    return err;
  }
};

export const fetchWrongDetails = async (lanId, token) => {
  let payload = {
    lanId: lanId ? lanId : "",
  };
  try {
    const response = await axios.post(Urls.wrongDetails, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from  wrong Details api--------------",
    );
    return err;
  }
};

export const createUpiMandate = async (lanId, vpaId, token) => {
  try {
    let payload = {
      lanId: lanId,
      vpaId: vpaId,
    };
    const response = await axios.post(Urls.createUpiMandate, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from create upi mandate modes api--------------",
    );
    return err;
  }
};

export const mandateStatus = async (mandateId, token) => {
  try {
    let payload = {
      mandateId: mandateId,
    };
    const response = await axios.post(Urls.mandateStatus, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from create upi mandate modes api--------------",
    );
    return err;
  }
};

export const createDebitCardMandate = async (
  accountNumber,
  lanId,
  ifsc,
  dob,
  phoneNumber,
  bankName,
  data,
  token,
) => {
  try {
    let payload = {
      applicationId: data?.application_id,
      lan: data?.lan,
      mobileNo: data?.mobile_no,
      firstName: data?.first_name,
      middleName: data?.middle_name ? data?.middle_name : "",
      lastName: data?.last_name ? data?.last_name : "",
      dob: dob,
      currentBankAcNo: accountNumber,
      pinCode: data?.pincode,
      loanAmount: data?.loan_amount,
      currentEmi: data?.current_emi,
      tenure: data?.tenure,
      sameBankAccountAllowed: data?.same_bank_account_allowed,
      bankName: bankName,
      ifscCode: ifsc,
      bankAcNo: data?.bank_ac_no,
      campaignStartDate: data?.campaign_start_date,
      campaignEndDate: data?.campaign_end_date,
      registrationStatus: data?.registration_status,
      typeOfCampaign: data?.type_of_campaign,
      productType: data?.product_type,
      noOfRemainingEmi: data?.no_of_remaining_emi,
      datelastupdt: data?.datelastupdt,
    };
    const response = await axios.post(Urls.createDebitCardMandate, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log(
      "------------ error while fetching data from create debit card mandate api--------------",
    );
    return err;
  }
};
